import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {KongService} from '../kong.service';
import {MatDialog, MatIconRegistry, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {FormControl} from '@angular/forms';
import {CreateDatabaseComponent, DialogOverviewExampleDialogComponent} from '../partner-onboard/partner-onboard.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
declare let $;
export interface DialogData {
  account_id: string;
  account_desc: string;
  account_email: string;
  account_password: string;
  account_roles: any;
}

export interface DatabaseData {
  database_name: string;
  database_type: string;
  username: string;
  password: string;
  host: string;
  port: string;
  dbName: string;
  connectionString: string;
}

export interface NameValuePair {
  name: string;
}
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  hide = true;
  columns: any;
  item: any;
  currentPlanDisplayName: string;
  name: string;
  database: string;
  apiKeys: any;
  apiKeyData: any;
  apiKey: any;
  identityProvider = 'Active Directory';
  supportedIdps: any;
  Accounts = false;
  Databases = false;
  logo = false;
  myControl = new FormControl();
  accountHeader = ['account', 'account_email', 'account_desc'];
  createAccount = {account_id: '', account_desc: '', account_email: '', account_password: ''};
  logoMarkPayload = {
    'logoType' : 'logoMark',
    'imageHeight' : 50,
    'imageWidth' : 50,
  };
  brandImagePayload = {
    'logoType': 'brandImage',
    'imageHeight': 60,
    'imageWidth': 180,
  };
  favIconPayload = {
    'logoType': 'favIcon',
    'imageHeight': 48,
    'imageWidth': 48,
  };
  dbColumns: any;
  partnerDatabases: any;
  defaultDB = 'mongodb';
  dataBaseData: any;
  captchaSiteKey: string;
  captach: string;
  couponCode: string;
  listOfDatabases = ['mongodb', 'dynamodb', 'mysql', 'postgresql', 'sqlserver', 'cosmosdb'];
  adfsData: any;
  adfsConfigs: any;
  identityProviders: NameValuePair[] = [
    {name: 'Active Directory'}
    // ,
    // {name: 'OKTA'},
    // {name: 'Microsoft Azure'},
    // {name: 'Google Suite'}
    // {name: 'VMWare Workspace One'}
  ];
  identityProviderName: string;
  identityProviderTypes: NameValuePair[] = [
    {name: 'SAML'}
  ];
  identityProviderType = 'SAML';
  metadataFilePath: string;
  appClientDetailsForPartner: any;
  registeredIdProviders: any;
  appClientID: any;
  getIPWhitelist: any;
  constructor(public platform: LeftpanelComponent, private confPost: ConfService, public dialog: MatDialog) { }

  ngOnInit() {
    this.setcolumnvalues();
    $('ul li ').click(function () {
      $(this).addClass('selected').siblings().removeClass('selected');
    });

    // this.confPost.getCaptchaSiteKey().subscribe(response => {
    //   this.captchaSiteKey = response[0]['value'];
    // });
  }
  setcolumnvalues(): any {
    return new Promise((resolve, reject) => {
      this.apiKey = localStorage.getItem('apikey');
      this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        this.item = data;
        resolve('success');
        // this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(this.item.primary_email).subscribe(keys => {
        //   this.apiKeyData = keys;
        //   this.apiKeys = this.apiKeyData.data;
        //   this.apiKey = this.apiKeys[0].key;
        // });
      }, error => {
        resolve('failure');
      });
    });
  }
  sendPartnerData() {
    this.item['accounts'] = [
      {
        account_id: this.item['partner'],
        account_desc: 'default',
        account_email: this.item['primary_email'],
        account_password: this.item['account_password'],
        account_roles: [],
        entities: [],
        operations: []
      }
    ];
    this.confPost.updatePartner(this.item).subscribe(data => {
      this.platform.openSnackBar('Updated successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      //  this.router.navigate(['/login']);
    }, error => {
      this.platform.openSnackBar('Error while data onboard. Please try after sometime', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  removeAccount(event, subAccount) {
    if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
      this.confPost.deleteAccount(localStorage.getItem('partner'), $(event.target).closest('td').next('td').text().trim()).subscribe(deleteData => {
        $(event.target).closest('td').parent('tr').remove();
        this.platform.openSnackBar('Account deleted successfully', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        const deleteSubAccountPayloadForAWS = {
          'partner': subAccount + '.' + localStorage.getItem('partner'),
          'type': 'dnsDelete'
        };
        this.confPost.createRoute53S3Bucket(deleteSubAccountPayloadForAWS).subscribe(response => {

        });
        //  this.router.navigate(['/login']);
      }, error => {
        this.platform.openSnackBar('Error. Please try after sometime', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    } else {
    }
  }

  removeDatabase(event) {
    if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
      this.confPost.deleteDatabase(localStorage.getItem('partner'), $(event.target).closest('td').next('td').text().trim()).subscribe(deleteData => {
        $(event.target).closest('td').parent('tr').remove();
        this.platform.openSnackBar('Database deleted successfully', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        //  this.router.navigate(['/login']);
      }, error => {
        this.platform.openSnackBar('Error. Please try after sometime', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    } else {
    }
  }

  editDatabase(event) {
    $(event.target).closest('td').parent('tr').find('td').each(function () {
      if ($(this).find('input').length) {
        $(this).find('input').prop('readonly', false);
      }
    });
  }

  typeOfval(val) {
    return typeof val;
  }

  stringifyjson(val) {
    return JSON.stringify(val);
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '500px',
      data: this.createAccount
    });

    dialogRef.afterClosed().subscribe(result => {
      // Handle this
    });
  }

  openDatabaseDialog(): void {
    const dialogRef = this.dialog.open(CreateDatabaseComponent, {
      width: '650px',
      data: this.dbColumns
    });

    dialogRef.afterClosed().subscribe(result => {
      //  Handle this
    });
  }
  getSelectedDB(val) {
    this.getSelectedDBColumn(val);
    this.dataBaseData = [];
    this.partnerDatabases.filter(items => {
      if (items.database_type === val) {
        this.dataBaseData.push(items);
      }
    });
  }


  getSelectedDBColumn(val) {
    const dbColumnsJSON =
        [
          {
            'database_name': '',
            'database_type': 'mongodb',
            // 'standardConnection': false,
            // 'srvConnection': false,
            'database_attributes': {
              'username': '',
              'password': '',
              'host': '',
              'port': '',
              'dbName': '',
              'connectionString': ''
            }
          },
          {
            'database_name': '',
            'database_type': 'dynamodb',
            'database_attributes': {
              'access_key': '',
              'secret_key': '',
              'region': ''
            }
          },
          {
            'database_name': '',
            'database_type': 'oracle',
            'database_attributes': {
              'username': '',
              'password': '',
              'host': '',
              'port': '',
              'dbName': '',
              'connectionString': ''
            }
          },
          {
            'database_name': '',
            'database_type': 'mysql',
            'database_attributes': {
              'username': '',
              'password': '',
              'host': '',
              'port': '',
              'dbName': '',
              'connectionString': ''
            }
          },
          {
            'database_name': '',
            'database_type': 'sqlserver',
            'database_attributes': {
              'username': '',
              'password': '',
              'host': '',
              'port': '',
              'dbName': '',
              'connectionString': ''
            }
          },
          {
            'database_name': '',
            'database_type': 'postgresql',
            'database_attributes': {
              'username': '',
              'password': '',
              'host': '',
              'port': '',
              'dbName': '',
              'connectionString': ''
            }
          },
          {
            'database_name': '',
            'database_type': 'cosmosdb',
            'database_attributes': {
              'accountName': '',
              'accountKey': '',
              'tableEndpoint': '',
              'endpointProtocol': ''
            }
          }
        ];
    const dataColumn = [];
    dbColumnsJSON.filter(items => {
      if (items.database_type === val) {
        dataColumn.push(items);
      }
    });
    this.dbColumns = [];
    const db_type = {};
    db_type['database_type'] = this.defaultDB;
    this.dbColumns.push(db_type);
    for (const item of dataColumn) {
      /*for (const itemval in item) {
          if (itemval != 'database_attribute') {
              this.dbColumns.push(itemval);
          }
      }*/
      for (const itemval in item.database_attributes) {
        this.dbColumns.push(itemval);
      }
    }
  }
  resolved(captchaResponse: string) {
    this.captach = captchaResponse;
  }

  sendPromoCode() {
    if (this.couponCode !== undefined && this.couponCode !== '') {
      if (this.captach !== null && this.captach !== undefined) {
        this.captach = null;
      } else {
        this.platform.openSnackBar('Perform captcha action to proceed', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.platform.openSnackBar('Please provide a coupon code to proceed', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }
  getDatabaseData(data) {
    this.confPost.updateDatabase(data, localStorage.getItem('partner')).subscribe(status => {
      this.platform.openSnackBar('Database updated successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      this.platform.openSnackBar('Error while updating database' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
    $('#databaseView').find('tbody tr').find('td').each(function () {
      if ($(this).find('input').length) {
        $(this).find('input').prop('readonly', true);
      }
    });
  }


  registerAdfsConfiguration(fileInput: any) {
    if (this.metadataFilePath) {
      this.confPost.registerIdentityProviderWithUrl(this.identityProviderName, this.identityProviderType, this.metadataFilePath).subscribe(data => {
        const describeClientData = {
          'customerName': localStorage.getItem('partner')
        };
        this.confPost.getAppClientDetailsForPartner(describeClientData).subscribe(data => {
          this.appClientDetailsForPartner = data;
          this.appClientID = this.appClientDetailsForPartner.customerId;
          if (this.appClientID) {
            this.supportedIdps = this.appClientDetailsForPartner.supportedIdps;
            this.supportedIdps.push(this.identityProviderName);
            const updateClientData = {
              'clientName': localStorage.getItem('partner'),
              'customerId': this.appClientID,
              'supportedIps': this.supportedIdps
            };
            this.confPost.updateAppClientSettings(updateClientData).subscribe(updateRes => {
              this.platform.openSnackBar('ADFS Configuration has been registered successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          }
        });
      }, error => {
        this.platform.openSnackBar('Error while registering ADFS Configuration' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    } else {
    }
  }
  sendIPWhitelist(text) {
    const ipWhitelist = [];
    if (text) {
      const textarray = text.replace(/\n/g, ',').split(',');
      textarray.forEach((data) => {
        ipWhitelist.push(data);
      });
    }
    this.confPost.updateIPWhitelist(localStorage.getItem('partner'), ipWhitelist).subscribe(data => {
      this.platform.openSnackBar('IP Whitelist added successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      this.platform.openSnackBar('Error while adding IP Whitelist' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

}
